/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from "@angular/core";
import { ISysqueTooltipFacade } from "../../../../../data-access/src/lib/domain/facades-models/sysque-tooltip-facade-interface";
import { LocalStorageService } from "../../../../../utils/src/lib/local-storage/local-storage.service";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class SysqueTooltipFacade implements ISysqueTooltipFacade {
    constructor(private localStorageService: LocalStorageService) { }

    getLocalStorageUpdate(): BehaviorSubject<string> {
        return this.localStorageService.localStorageUpdate$;
    }
}